import requests from "./request";

// 获取菜单
export const AddMoudle = async (param)=>{
    return await requests('Module',param,'GET',0)
}
// 获取菜单信息
export const GetModuleList = async (param)=>{
    return await requests('Module/GetModuleList',param,'GET',0)
}

//添加菜单信息
export const InsertModule = async (param)=>{
    return await requests('Module',param,'POST',1)
}

//删除菜单信息
export const DeleteModule = async (param)=>{
    return await requests('Module/'+param,param,'POST',1)
}

//修改权限所拥有的菜单
export const Update = async (ID,param)=>{
    return await requests(`Module/Update/${ID}`,param,'POST',1);
}

// 根据权限获取相关菜单信息
export const GetListByRoleID = async (param)=>{
    return await requests('Role/GetListByRoleID',param,'POST',1)
}

// 根据权限获取相关菜单信息
export const GetListByRole = async (param)=>{
    return await requests(`Role`,param,'GET',0)
}

export const GetRoleByID = async (param)=>{
    return await requests(`Role/GetRoleByID`,param,'POST',1)
}